import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyWhatsApp from "@/components/StickyWhatsApp";

const PageShell = ({ children, headerLight = true }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="bg-stone-50 min-h-screen">
      <Header light={headerLight} />
      <main>{children}</main>
      <Footer />
      <StickyWhatsApp />
      <Toaster position="bottom-center" />
    </div>
  );
};

export default PageShell;
